module.exports = __webpack_public_path__ + "static/media/bussiness4.64e0861a.png";